export const OptionsList = ({ data }) => {
  return (
    <ul className="app-ai-quote-options-list">
      {data.map((option, index) => (
        <li className="app-ai-quote-options-list-item" key={index}>
          <span className="app-ai-quote-options-list-icon">
            <svg
              width="12"
              height="12"
              viewBox="0 0 12 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10 3L4.5 8.5L2 6"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
          <div className="app-ai-quote-options-list-content">
            <p className="app-ai-quote-options-list-name">{option.name}</p>
            {option.description && <p>{option.description}</p>}
            {option.items && (
              <ul className="app-ai-quote-options-list-sub-list">
                {option.items.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            )}
          </div>
        </li>
      ))}
    </ul>
  );
};
